<div class="At-StoryMain ">
    <div class="At-StoryHead">
        <h5>Stories</h5>
    </div>
    <div class="At-CreateStoryHolder">
      <a routerLink="/story-go-live" class="At-StoryBox">
        <div class="At-CreateStory">
          <i class="icon-add"></i>
          <p>create a story</p>
        </div>
      </a>
      <a href="javascript:void(0);" class="At-StoryBox">
        <div class="At-CreateStory">

        </div>
      </a>
      <a href="javascript:void(0);" class="At-StoryBox">
        <div class="At-CreateStory">

        </div>
      </a>
      <a href="javascript:void(0);" class="At-StoryBox">
        <div class="At-CreateStory">

        </div>
      </a>
      <a href="javascript:void(0);" class="At-StoryBox">
        <div class="At-CreateStory">

        </div>
      </a>
    </div>
  <!-- At-StoryBox ends -->
    <a routerLink="/stories" class="At-StoryBox">
        <figure class="At-StoryMainfigure">
            <img src="assets/images/profile/story-img.png" class="img-fluid At-ImgW100" alt="">
        </figure>
        <div class="At-StoryText">
            <figure class="At-StorySmallFigure">
                <img src="assets/images/profile/story-img-small.png" alt="">
            </figure>
            <p class="At-StoryTitle">Jacob</p>
        </div>
    </a>
    <!-- At-StoryBox ends -->
    <a routerLink="/story-live" class="At-StoryBox">
        <figure class="At-StoryMainfigure">
            <img src="assets/images/profile/story-img2.png" class="img-fluid At-ImgW100" alt="">
        </figure>
        <div class="At-StoryText">
            <figure class="At-StorySmallFigure">
                <img src="assets/images/profile/story-img-small2.png" alt="">
                <a class="At-Livetag" >live</a>
            </figure>
            <p class="At-StoryTitle">Anatoli</p>
        </div>
    </a>
    <!-- At-StoryBox ends -->
    <a routerLink="/stories" class="At-StoryBox">
        <figure class="At-StoryMainfigure">
            <img src="assets/images/profile/story-img3.png" class="img-fluid At-ImgW100" alt="">
        </figure>
        <div class="At-StoryText">
            <figure class="At-StorySmallFigure">
                <img src="assets/images/profile/story-img-small3.png" alt="">
            </figure>
            <p class="At-StoryTitle">Softpetal</p>
        </div>
    </a>
    <!-- At-StoryBox ends -->
    <a routerLink="/stories" class="At-StoryBox">
        <figure class="At-StoryMainfigure">
            <img src="assets/images/profile/story-img.png" class="img-fluid At-ImgW100" alt="">
        </figure>
        <div class="At-StoryText">
            <figure class="At-StorySmallFigure">
                <img src="assets/images/profile/story-img-small4.png" alt="">
            </figure>
            <p class="At-StoryTitle">Sarah</p>
        </div>
    </a>
    <!-- At-StoryBox ends -->
    <a routerLink="/stories" class="At-StoryBox">
        <figure class="At-StoryMainfigure">
            <img src="assets/images/profile/story-img4.png" class="img-fluid At-ImgW100" alt="">
        </figure>
        <div class="At-StoryText">
            <figure class="At-StorySmallFigure">
                <img src="assets/images/profile/story-img-small3.png" alt="">
            </figure>
            <p class="At-StoryTitle">Betty.S</p>
        </div>
    </a>
    <!-- At-StoryBox ends -->
    <a routerLink="/stories" class="At-StoryBox">
        <figure class="At-StoryMainfigure">
            <img src="assets/images/profile/story-img.png" class="img-fluid At-ImgW100" alt="">
        </figure>
        <div class="At-StoryText">
            <figure class="At-StorySmallFigure">
                <img src="assets/images/profile/story-img-small.png" alt="">
            </figure>
            <p class="At-StoryTitle">Jacob</p>
        </div>
    </a>
    <!-- At-StoryBox ends -->
    <a routerLink="/stories" class="At-StoryBox">
        <figure class="At-StoryMainfigure">
            <img src="assets/images/profile/story-img4.png" class="img-fluid At-ImgW100" alt="">
        </figure>
        <div class="At-StoryText">
            <figure class="At-StorySmallFigure">
                <img src="assets/images/profile/story-img-small3.png" alt="">
            </figure>
            <p class="At-StoryTitle">Betty.S</p>
        </div>
    </a>
    <!-- At-StoryBox ends -->
    <a routerLink="/stories" class="At-StoryBox">
        <figure class="At-StoryMainfigure">
            <img src="assets/images/profile/story-img.png" class="img-fluid At-ImgW100" alt="">
        </figure>
        <div class="At-StoryText">
            <figure class="At-StorySmallFigure">
                <img src="assets/images/profile/story-img-small.png" alt="">
            </figure>
            <p class="At-StoryTitle">Jacob</p>
        </div>
    </a>
    <!-- At-StoryBox ends -->
</div>
